import Link from 'next/link';
import React from 'react'

const MenuItemContent = ({ item }) => {
  return (
    <Link
      href={item.url}
      title={item.title}
      prefetch={false}
      className="px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-300"
    >
      {item.baslik}
    </Link>
  );
}

export default MenuItemContent